module.exports = "/_next/static/images/e15fdae704986353baa4578b5a50149a-pix-transfer@1x.png.webp";